<template>
  <div class="page">
    <query-select
      class="query-box"
      ref="queryselect"
    ></query-select>
    <div class="page-header white-bg">
       <size-change @sizeChange="sizeChange"></size-change>
      <div class="header-right">
        <vs-input
          class="search-words"
          v-model="words"
          placeholder="支付流水号/商户订单号/商户支付流水号"
          style="width: 230px;"
        ></vs-input>
        <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
      </div>
    </div>
    <div class="page-content white-bg">
      <vs-table :data="listData">
        <template slot="thead">
          <vs-th>
            支付流水号
          </vs-th>
          <vs-th>
            商户编码
          </vs-th>
          <vs-th class="merchant-order-col">
            商户订单号
          </vs-th>
          <vs-th>
            商户支付流水号
          </vs-th>
          <vs-th>
            产品编码
          </vs-th>
          <vs-th class="real-curreny">
            渠道编码
          </vs-th>
          <vs-th>
            支付币种
          </vs-th>
          <vs-th>
            支付金额
          </vs-th>
          <vs-th class="real-curreny">
            实际支付币种
          </vs-th>
          <vs-th class="total-amount">
            实际支付金额
          </vs-th>
          <vs-th class="fee-th">
            手续费
          </vs-th>
          <vs-th class="status-col">
            支付状态
          </vs-th>
          <vs-th class="time-th">
            创建时间
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(tr, index) in data" >
            <vs-td>
              {{tr.serialNo}}
            </vs-td>

            <vs-td>
              {{tr.merCode}}
            </vs-td>

            <vs-td class="merchant-order-col">
              <div>{{tr.merOrderNo}}</div>
            </vs-td>
            <vs-td>
              <div>{{tr.merSerialNo}}</div>
            </vs-td>
            <vs-td>
              {{tr.busProductCode}}
            </vs-td>
            <vs-td>
              <span
                class="channel-code"
                :class="{
                  'can-click': tr.walletAddress
                }"
                @click="addressHandle(tr)"
              >
                {{tr.busChannelCode}}
              </span>
            </vs-td>
            <vs-td class="busCurrency">
              {{tr.busCurrency}}
            </vs-td>
            <vs-td class="busAmount">
              {{tr.busAmount}}
            </vs-td>
            <vs-td class="real-curreny">
              {{tr.payRealCurrency}}
            </vs-td>
            <vs-td class="total-amount">
              {{tr.payRealAmount}}
            </vs-td>

            <vs-td class="fee-th">
              {{tr.peyFee  }}
            </vs-td>
            <vs-td class="status-col">
                <span
                  class="status"
                  :class="{
                  grey: tr.payStatus == 201 || tr.payStatus == 205 || tr.payStatus == 206,
                   green: tr.payStatus == 202,
                   red: tr.payStatus == 203,
                   orange: tr.payStatus == 204
                   }"
                >{{getState(tr)}}</span>
            </vs-td>
            <vs-td class="time-th">
              {{tr.createTime}}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="pagination-outer" v-if="total">
        <span class="tatol-count">共计{{total}}条</span>
        <vs-pagination
          class="pagination-box"
          :max="size"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { parseTime } from "../../../utils";
  import querySelect from '@/components/product/orderManage/querySelect'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      querySelect,
    },
    data() {
      return {
        addDialogShow: false,
        editData: {},
        active: false,
        currentId: 0,
      }
    },
    mixins: [initData],
    mounted(){
      this.init();
    },
    methods: {
      addressHandle(tr){
        if(tr.walletAddress){
          window.open(tr.walletAddress,'_blank');
        }
      },
      beforeInit(){
        this.url = 'pms/crm/pageOrder';
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        if(this.$refs.queryselect.merchantCode){
          this.params.merCode = this.$refs.queryselect.merchantCode;
        }
        if(this.$refs.queryselect.productCode){
          this.params.busProductCode = this.$refs.queryselect.productCode;
        }
        if(this.$refs.queryselect.channelCode){
          this.params.busChannelCode = this.$refs.queryselect.channelCode;
        }
        if(this.$refs.queryselect.payStatus){
          this.params.payStatus = this.$refs.queryselect.payStatus;
        }
        if(this.$refs.queryselect.orderDate && this.$refs.queryselect.orderDate.length){
          this.params.startTime = parseTime(this.$refs.queryselect.orderDate[0]);
        }
        if(this.$refs.queryselect.orderDate && this.$refs.queryselect.orderDate.length){
          this.params.endTime = parseTime(this.$refs.queryselect.orderDate[1]);
        }
        return true;
      },
      getState(tr){
        switch (+tr.payStatus) {
          case 201:
            return '未支付';
            break;
          case 202:
            return '支付成功';
            break;
          case 203:
            return '支付失败';
            break;
          case 204:
            return '支付中';
            break;
          case 205:
            return '已过期';
            break;
          case 206:
            return '转账退款';
            break;
        }
      },
    },
  }
</script>
<style lang="scss">
  .page {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .time-th {
    min-width: 120px;
  }
  .fee-th,
  .real-curreny {
    min-width: 80px;
  }
  .channel-code {
    &.can-click {
      cursor: pointer;
      color: #5D9EF8;
    }
  }
  .total-amount {
    min-width: 110px;
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .busCurrency,
  .busAmount {
    min-width: 110px;
  }
  .real-curreny {
    min-width: 130px;
  }
  .status {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 17px;
    &.red {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
    &.green {
      background-color: rgba(0, 128, 0, 0.12);
      color: green;
    }
    &.orange {
       background-color: rgba(255, 165, 0, 0.12);
       color: orange;
    }
    &.grey {
      background-color: rgba(128, 128, 128, 0.12);
      color: grey;
    }
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .status-col {
    min-width: 120px;
  }
  .merchant-order-col {
    min-width: 100px;
  }
</style>
